<template>
  <dialog-scroll-lock persistent width="300" :value="value" @input="v => $emit('input', v)">
    <v-card class="relative">
      <v-card-title>Print options</v-card-title>
      <v-card-subtitle>Note that your browser / printer may override these options</v-card-subtitle>
      <v-card-text>
        <v-checkbox class="mt-0 pt-0" hide-details label="Include margins" v-model="margin" />
        <v-checkbox hide-details label="Include borders" v-model="border" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn text @click="$emit('input', false)">Cancel</v-btn>
        <v-btn text color="primary" :disabled="!loaded" :loading="!loaded" @click="print">Print</v-btn>
      </v-card-actions>

      <iframe
        ref="print"
        style="position: absolute; border: none; width: 0; height: 0; margin: 0; padding: 0;"
        :src="url"
      />

    </v-card>
  </dialog-scroll-lock>
</template>

<script>
import { mdiAlert } from '@mdi/js';

export default {
  name: 'print-dialog',

  props: [ 'token', 'value' ],

  data() {
    return {
      margin: false,
      border: false,
      loaded: false
    };
  },

  computed: {
    url() {
      const q = {};
      for (const key of [ 'margin', 'border' ])
        if (this[key])
          q[key] = 1;
      return `/_/print/${this.token}?${(new URLSearchParams(q)).toString()}`;
    }
  },

  created() {
    Object.assign(this, { mdiAlert });
    addEventListener('message', this.onMessage);
  },

  beforeDestroy() {
    removeEventListener('message', this.onMessage);
  },

  methods: {
    print() {
      const el = this.$refs.print;
      el.focus();
      el.contentWindow.addEventListener('afterprint', this.onAfterPrint);
      el.contentWindow.print();
    },

    onMessage(e) {
      try {
        const { src, key } = JSON.parse(e.data);
        if ((src == 'ellacard-print') && (key == 'pagesloaded'))
          this.loaded = true;
      } catch (e) {
      }
    },

    onAfterPrint(e) {
      this.$emit('input', false);
    }
  },

  watch: {
    url() {
      this.loaded = false;
    }
  }
}
</script>
